module.exports = __webpack_public_path__ + "img/asicom.3b7e7be8.png";